<template>
  <div class="sl-sider-container">
    <Menu :accordion="true" :theme="theme != 'ios' ? theme : undefined" width="auto" :active-name="defActive" :open-names="openMenus" @on-select="selectMenu">
      <aside-item v-for="(item,index) in menus" :item="item" :name="item.id" :key="'menu'+index"></aside-item>
    </Menu>
  </div>
</template>
<script>
import AsideItem from './item'

export default {
  data() {
    return {

    }
  },
  props: {
    menus: { type: Array },
    openMenus: { type: Array },
    theme:{type:String , default:'dark'}
  },

  computed: {

    defActive() {
      return this.$route.name
    }
  },

  methods: {
    selectMenu(name) {
      this.$emit('change' , name)
    },

    closeAll() {}
  },
  components: { AsideItem }
}

</script>
